import BaseApiService from "./BaseApiService";

class LearnerCategoryService extends BaseApiService {
    getLearnerCategories = async (params = {}) => {
        const { page = 1, pageSize = 10, limit, search = "" } = params;
        try{
            const response = await this.getAxiosInstance().get("/categories",{
                params: {
                    page,
                    limit: limit || pageSize,
                    search: search.trim(),
                },
            });
            return {
                categories: response.data?.data?.categories.map(category => ({
                    ...category,
                    key: category._id
                })) || [],
                pagination: response.data?.data?.pagination || {},
            };
        }catch (error) {
            console.error("Error getting learner categories:", error);
            throw error;
        }
    }
}
export default new LearnerCategoryService();